import '.d{display:flex;}.ssr-plugin'
import '.a8{align-items:stretch;}.ssr-plugin'
import '.ad{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.e0{background:var(--palette-white);}.ssr-plugin'
import '.ao{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ag{max-width:77.5rem;}.ssr-plugin'
import '.fk{justify-content:stretch;}.ssr-plugin'
import '.c1{position:sticky;}.ssr-plugin'
import '.bm{top:0px;}.ssr-plugin'
import '.c5{z-index:10;}.ssr-plugin'
import '.fl{padding-block:1rem;}.ssr-plugin'
import '.fm{height:3rem;}.ssr-plugin'
import '.ar{justify-content:space-between;}.ssr-plugin'
import '.au{flex-wrap:wrap;}.ssr-plugin'
import '.fn{margin-bottom:0px;}.ssr-plugin'
import '.fo{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.et{margin-top:2rem;}.ssr-plugin'
import '.fp{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="d a8 ad e e0"
      >
        <div className="ao d r ad e"
        >
          <div className="ag d e fk c1 bm c5 e0"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="fl fm d ar r au"
            >
              <styled.span className="fn"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="fo d e a8 et fp ag"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
